import {validateUrl} from '../utils/validateUrl/validateUrl';

function filterLinks(externalLinks = []) {
  return externalLinks.filter(({service, url}) => {
    const isValid = validateUrl(url);
    if (!isValid) {
      // eslint-disable-next-line no-console
      console.warn('Filtering out invalid Service Url', service, url);
      return false;
    }
    return true;
  });
}

export function filterOutInvalidExternalsUrls(album) {
  return {
    ...album,
    ...(album.albumExternalLinks ? {albumExternalLinks: filterLinks(album.albumExternalLinks)} : {}),
    tracks: album.tracks.map((track) => ({
      ...track,
      ...(track.trackExternalLinks ? {trackExternalLinks: filterLinks(track.trackExternalLinks)} : {}),
    })),
  };
}
